import React from 'react';
import { observer } from 'mobx-react';
import { Select, Typography, Tag } from 'antd';
import { Trans } from 'react-i18next';
import classNames from 'classnames';
import { MySelect } from '../../Base/Form';
import { useStore } from '../../../store/rootStore';
import styles from './LabelsFilter.module.scss';
const { Option } = Select;
const { Text } = Typography;
const LabelsFilter = ({ fullwidth }) => {
    const { labels: labelsStore, chatsStore } = useStore();
    const handleChange = (value) => {
        chatsStore.setLabelsFilter(value);
    };
    const selectedLabels = chatsStore.searchFilter.labels || [];
    const tagRender = (props) => {
        const { label, value, closable, onClose } = props;
        const selectedLabel = labelsStore.labels.find(l => l.id === value);
        const onPreventMouseDown = (event) => {
            event.preventDefault();
            event.stopPropagation();
        };
        return (React.createElement(Tag, { color: (selectedLabel === null || selectedLabel === void 0 ? void 0 : selectedLabel.color) || 'lightgrey', onMouseDown: onPreventMouseDown, closable: closable, onClose: onClose, style: { marginInlineEnd: 4 }, className: styles.labelTag }, (selectedLabel === null || selectedLabel === void 0 ? void 0 : selectedLabel.name) || label));
    };
    console.log({ selectedLabels });
    return (React.createElement(MySelect, { className: classNames(styles.container, {
            [styles.fullwidth]: fullwidth,
            [styles.active]: selectedLabels.length > 0,
        }), value: selectedLabels, onChange: handleChange, virtual: false, fullWidth: fullwidth, mode: "multiple", allowClear: true, tagRender: tagRender, placeholder: React.createElement("div", { className: classNames(styles.filterAgentsContent, styles.placeholder) },
            React.createElement("div", { style: { backgroundColor: 'lightgrey' }, className: styles.filterAgentColor }),
            React.createElement(Text, null,
                React.createElement(Trans, { i18nKey: "allLabels", defaults: "All Labels" }))), onClick: (e) => {
            /* Allow filter to be open within a modal */
            e.stopPropagation();
        } }, labelsStore.labels.map((label) => (React.createElement(Option, { key: label.id, id: label.id, value: label.id, className: styles.filterAgentsOption },
        React.createElement(Tag, { color: label.color || 'lightgrey', className: styles.labelTag }, label.name))))));
};
export default observer(LabelsFilter);
